import {
  Clock3Icon,
  HotelIcon,
  PlaneIcon,
  ShieldCheckIcon,
} from "lucide-react";

import { Button } from "@/components/ui/button";

const STARTER_PROMPTS = [
  {
    icon: PlaneIcon,
    title: "Fast Flight Plan",
    description: "Find me non-stop flights from Dhaka to Cox's Bazar tomorrow.",
  },
  {
    icon: ShieldCheckIcon,
    title: "Refundable Under Budget",
    description: "Show refundable flights under 10,000 BDT.",
  },
  {
    icon: HotelIcon,
    title: "Luxury Stay Picks",
    description: "Find 5-star hotels in Cox's Bazar for 3 nights.",
  },
  {
    icon: Clock3Icon,
    title: "Early Departure",
    description: "I need flights to Bangkok before 9am.",
  },
] as const;

type AiPlannerStarterViewProps = {
  onSendPrompt: (prompt: string) => void;
};

export function AiPlannerStarterView({
  onSendPrompt,
}: AiPlannerStarterViewProps) {
  return (
    <div className="relative mx-auto h-full w-full max-w-3xl overflow-x-hidden px-3 sm:px-6">
      <div className="flex h-full items-center justify-center pb-20">
        <div className="w-full min-w-0 space-y-8">
          <div className="mx-auto max-w-xl space-y-3 text-center">
            <h1 className="text-balance text-3xl font-semibold tracking-tight sm:text-4xl">
              Where do you want to go?
            </h1>
            <p className="text-muted-foreground text-sm sm:text-base">
              Ask flights, hotels, and travel ideas in one chat.
            </p>
          </div>

          <div className="grid w-full gap-2.5 sm:grid-cols-2">
            {STARTER_PROMPTS.map((prompt) => (
              <Button
                key={prompt.description}
                type="button"
                variant="ghost"
                className="group h-auto w-full justify-start rounded-2xl border border-border/80 bg-background/90 px-4 py-4 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/25 hover:bg-background hover:shadow-md overflow-hidden"
                onClick={() => onSendPrompt(prompt.description)}
              >
                <span
                  aria-hidden="true"
                  className="mr-3 rounded-xl border border-border/70 bg-muted/70 p-2 transition-colors duration-200 group-hover:border-primary/25 group-hover:bg-primary/5"
                >
                  <prompt.icon className="size-4 text-primary/90" />
                </span>
                <span className="min-w-0 space-y-0.5">
                  <span className="block text-sm font-semibold">
                    {prompt.title}
                  </span>
                  <span className="text-muted-foreground block break-words text-xs font-normal">
                    {prompt.description}
                  </span>
                </span>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
